import { PLANOS as PLANOS_V3 } from "@/lib/plans-v3";

export const PLANS = {
  free: {
    name: "Grátis",
    description: "Ideal para quem está começando a organizar seus aluguéis",
    product_id: "prod_U73mE4QOIxqKPv",
    monthly: { price_id: "price_1T8pf0D85maAQgQcgKTWtRVT", price: 0 },
    annual: null,
    features: [
      "Gestão de até 2 imóveis",
      "2 contratos ativos",
      "Geração automática de cobranças mensais",
      "Controle manual de pagamentos",
      "Relatórios básicos",
      "Dashboard simplificado",
    ],
    limits: { imoveis: 2, contratos: 2 },
    cta: "Começar grátis",
    trial: false,
  },
  premium: {
    name: "Premium",
    description: "Para proprietários que gerenciam uma carteira em crescimento",
    product_id: "prod_U73ngnYHFuTyiL",
    monthly: { price_id: "price_1T8pftD85maAQgQcNywqYqcw", price: 29.9 },
    annual: { price_id: "price_1T8phiD85maAQgQcS4EM1MeI", price: 287 },
    features: [
      "Gestão de até 5 imóveis",
      "Até 5 contratos ativos",
      "Geração automática de cobranças mensais",
      "Controle manual de pagamentos",
      "Relatórios e indicadores avançados",
      "Dashboard executivo completo",
      "Alertas automáticos de vencimento e inadimplência",
      "Exportação de relatórios em PDF e CSV",
      "Histórico financeiro completo",
    ],
    limits: { imoveis: 5, contratos: 5 },
    cta: "Iniciar teste grátis",
    trial: true,
    popular: true,
  },
  plus: {
    name: "Plus",
    description: "Para investidores e gestores de carteiras imobiliárias",
    product_id: "prod_U73oVveX6yhRgj",
    monthly: { price_id: "price_1T8pgrD85maAQgQczZNpNyFI", price: 49.9 },
    annual: { price_id: "price_1T8pijD85maAQgQc40BsEG0u", price: 479 },
    features: [
      "Imóveis e contratos ilimitados",
      "Tudo do plano Premium",
      "Relatórios executivos avançados",
      "Controle avançado de inadimplência",
      "Exportação completa de dados",
      "Suporte prioritário",
    ],
    limits: { imoveis: Infinity, contratos: Infinity },
    cta: "Iniciar teste grátis",
    trial: true,
  },
} as const;

/**
 * Chave de plano — a nova escada e as antigas, juntas de propósito.
 *
 * "starter", "plus" e "business" são do catálogo anterior e continuam existindo
 * porque contas de cortesia e assinaturas antigas resolvem por elas. Apagá-las
 * do tipo não apagaria as linhas no banco: só faria o código deixar de enxergar
 * o que ele precisa continuar respeitando.
 *
 * O catálogo NOVO (Free, Essencial, Profissional, Premium, Enterprise) vive em
 * `@/lib/plans-v3`, lido do instantâneo gerado do banco.
 */
export type PlanKey =
  | "free" | "starter" | "premium" | "plus" | "business"
  | "essential" | "professional" | "enterprise";

// ── PLANS V2 (pricing novo, ativado via feature flag pricing_v2_enabled) ──
export const PLANS_V2 = {
  free: {
    name: "Gratuito",
    description: "Ideal para começar a organizar seus aluguéis",
    product_id: null as string | null,
    monthly: { price_id: null as string | null, price: 0 },
    annual: null as { price_id: string; price: number } | null,
    features: [
      "Gestão de até 2 imóveis",
      "2 contratos ativos",
      "Cobranças automáticas",
      "Dashboard básico",
      "Relatórios básicos",
    ],
    limits: { imoveis: 2, contratos: 2 },
    cta: "Começar grátis",
  },
  starter: {
    name: "Starter",
    description: "Para proprietários que querem controle profissional",
    product_id: "prod_UkQIHNWsBqYku0",
    monthly: { price_id: "price_1TkvRqD85maAQgQctorlCVOJ", price: 19.90 },
    annual: { price_id: "price_1TkvRsD85maAQgQcp0dk9pqw", price: 191 },
    features: [
      "Gestão de até 3 imóveis",
      "3 contratos ativos",
      "Alertas por email",
      "1 relatório IR por ano",
      "Recibos automáticos",
    ],
    limits: { imoveis: 3, contratos: 3 },
    cta: "Assinar Starter",
  },
  premium: {
    name: "Premium",
    description: "Para investidores com carteira em crescimento",
    product_id: "prod_UkQH6XHrwD9XPS",
    monthly: { price_id: "price_1TkvRtD85maAQgQcKJaeOyTq", price: 49.90 },
    annual: { price_id: "price_1TkvRuD85maAQgQcYGRbnIDX", price: 479 },
    features: [
      "Gestão de até 10 imóveis",
      "10 contratos ativos",
      "Dashboard executivo completo",
      "Todos os relatórios + IR completo",
      "Alertas email + WhatsApp",
      "PIX Automático",
      "IA: score de inadimplência",
      "Exportação PDF/CSV/XLSX",
    ],
    limits: { imoveis: 10, contratos: 10 },
    cta: "Assinar Premium",
    popular: true,
  },
  plus: {
    name: "Plus",
    description: "Para investidores profissionais e administradoras",
    product_id: "prod_UkQIiPZrXgNdM7",
    monthly: { price_id: "price_1TkvRvD85maAQgQcRUjtnGsY", price: 99.90 },
    annual: { price_id: "price_1TkvRwD85maAQgQcBTzvauTN", price: 959 },
    features: [
      "Imóveis e contratos ilimitados",
      "Tudo do Premium",
      "IA completa: copilot + precificação",
      "GIFI Pay: boleto + split",
      "API aberta",
      "Marketplace de serviços",
      "Suporte prioritário",
    ],
    limits: { imoveis: Infinity, contratos: Infinity },
    cta: "Assinar Plus",
  },
  business: {
    name: "Business",
    description: "Para administradoras e imobiliárias",
    product_id: "prod_UkQIftByQoKyN3",
    monthly: { price_id: "price_1TkvRyD85maAQgQcV9uTdwfr", price: 199.90 },
    annual: { price_id: "price_1TkvRzD85maAQgQcg6kUJdjS", price: 1919 },
    features: [
      "Tudo do Plus",
      "Multi-usuário (até 10 membros)",
      "White-label (logo e cores customizadas)",
      "Suporte dedicado",
      "Onboarding assistido",
    ],
    limits: { imoveis: Infinity, contratos: Infinity },
    cta: "Falar com vendas",
  },
};

export function getPlanByProductId(productId: string): PlanKey {
  // V1 plans
  for (const [key, plan] of Object.entries(PLANS)) {
    if (plan.product_id === productId) return key as PlanKey;
  }
  // V2 plans — starter maps to "starter", all others map to "plus"
  if (productId === "prod_UkQIHNWsBqYku0") return "starter";
  if (productId === "prod_UkQH6XHrwD9XPS") return "plus"; // Premium V2 → plus gate
  if (productId === "prod_UkQIiPZrXgNdM7") return "plus"; // Plus V2
  if (productId === "prod_UkQIftByQoKyN3") return "plus"; // Business
  return "free";
}

// Feature comparison table data
export const FEATURE_COMPARISON = [
  { feature: "Imóveis", free: "2", premium: "até 5", plus: "Ilimitados" },
  { feature: "Contratos ativos", free: "2", premium: "até 5", plus: "Ilimitados" },
  { feature: "Cobranças automáticas", free: true, premium: true, plus: true },
  { feature: "Controle de pagamentos", free: true, premium: true, plus: true },
  { feature: "Relatórios básicos", free: true, premium: true, plus: true },
  { feature: "Relatórios avançados", free: false, premium: true, plus: true },
  { feature: "Dashboard executivo", free: false, premium: true, plus: true },
  { feature: "Alertas de vencimento", free: false, premium: true, plus: true },
  { feature: "Exportação PDF/CSV", free: false, premium: true, plus: true },
  { feature: "Histórico financeiro", free: false, premium: true, plus: true },
  { feature: "Imóveis ilimitados", free: false, premium: false, plus: true },
  { feature: "Relatórios executivos avançados", free: false, premium: false, plus: true },
  { feature: "Suporte prioritário", free: false, premium: false, plus: true },
] as const;

// Premium features that require subscription
export const PREMIUM_FEATURES = [
  "advanced_reports",
  "executive_dashboard",
  "expiry_alerts",
  "pdf_csv_export",
  "financial_history",
  "advanced_delinquency",
  "portal_externo",
  "analytics_avancado",
] as const;

export type PremiumFeature = typeof PREMIUM_FEATURES[number];

/** Recursos que exigem o 4º degrau: `plus` na escada antiga, `premium` na nova. */
const RECURSOS_DO_QUARTO_DEGRAU: PremiumFeature[] = [
  "advanced_delinquency",
  "portal_externo",
  "analytics_avancado",
];

/**
 * A escada de cada catálogo, por DEGRAU — a mesma de `usePlan`.
 *
 * O número é a posição, não o preço. "premium" é o 3º degrau na escada antiga
 * (R$ 29,90, 5 imóveis) e o 4º na nova (R$ 129,90, 30 imóveis), e é por isso
 * que as duas não se misturam num ranking só.
 */
export const DEGRAU_ESCADA_ANTIGA: Record<string, number> = {
  free: 0, starter: 1, premium: 2, plus: 3, business: 4,
};
export const DEGRAU_ESCADA_NOVA: Record<string, number> = {
  free: 0, essential: 1, professional: 2, premium: 3, enterprise: 4,
};

/**
 * O portão de recurso premium, expresso em DEGRAU em vez de nome de plano.
 *
 * Ele dizia `plan === "premium" || plan === "plus"`, dois nomes da escada de
 * 2025. Consequências medidas em 10/09/2026:
 *
 *   · **Profissional (R$ 69,90) e Enterprise eram NEGADOS** em todos os
 *     relatórios avançados. A conta pagava e via o cadeado.
 *   · **Business, da escada antiga, também era negado** — ele está ACIMA de
 *     plus e não estava na lista. Defeito antigo, que ninguém tinha visto.
 *   · O Premium v3 passava por acidente: mesmo nome, outro degrau.
 *
 * Por degrau, as duas escadas respondem sem se misturar, e o comportamento das
 * contas legadas fica idêntico ao de antes — menos o Business, que passa a
 * receber o que sempre deveria.
 *
 * **O que esta função deliberadamente NÃO faz:** ler a matriz `plan_features`
 * do catálogo. Os dois vocabulários não se correspondem um a um — `plan_features`
 * fala em `exportacao` e `relatorio_ir`, este portão fala em `advanced_reports`
 * e `pdf_csv_export` —, e inventar o mapa seria decidir por conta própria o que
 * cada plano vende. Alinhar os dois é decisão de produto, e está registrada
 * como tal no plano de obra.
 *
 * @param versao qual escada vale para esta conta. Sem ela, vale a que contém o
 *               nome do plano — e, no empate ("premium" está nas duas), a
 *               antiga, que é onde estão as contas de hoje.
 */
export function canAccessFeature(
  plan: PlanKey,
  feature: PremiumFeature,
  versao?: string | null,
): boolean {
  const escada = versao === "v3"
    ? DEGRAU_ESCADA_NOVA
    : versao
      ? DEGRAU_ESCADA_ANTIGA
      : (plan in DEGRAU_ESCADA_ANTIGA ? DEGRAU_ESCADA_ANTIGA : DEGRAU_ESCADA_NOVA);

  const meu = escada[plan];
  // Plano fora desta escada não passa: falhar fechado é o certo num portão.
  if (meu === undefined) return false;

  if (RECURSOS_DO_QUARTO_DEGRAU.includes(feature)) return meu >= 3;
  if ((PREMIUM_FEATURES as readonly string[]).includes(feature)) return meu >= 2;
  return true;
}

/**
 * Limites de emergência, usados só quando a RPC `get_current_plan_limits` não
 * responde. A fonte de verdade é `plan_limits` no banco — a mesma tabela que as
 * policies de INSERT consultam.
 *
 * Os valores do catálogo NOVO saem do instantâneo; os legados ficam escritos
 * porque não existe mais catálogo v1/v2 de onde tirá-los.
 */
const limitesDoCatalogo = Object.fromEntries(
  PLANOS_V3.map((p) => [p.key, {
    imoveis: p.maxImoveis ?? Infinity,
    contratos: p.maxContratos ?? Infinity,
  }]),
) as Record<string, { imoveis: number; contratos: number }>;

export const PLAN_LIMITS: Record<PlanKey, { imoveis: number; contratos: number }> = {
  starter:  { imoveis: 3,        contratos: 3 },
  plus:     { imoveis: Infinity, contratos: Infinity },
  business: { imoveis: Infinity, contratos: Infinity },
  // "premium" existe nas duas escadas com números diferentes: 5/5 na antiga,
  // 30/ilimitado na nova. Este mapa é só o SOCORRO de quando a RPC não responde,
  // e nele vale o número ANTIGO — errar para menos mostra "faça upgrade" a quem
  // podia cadastrar; errar para mais convida a um cadastro que o banco recusa.
  // Quem está na escada nova recebe o limite certo do próprio banco.
  premium:  { imoveis: 5,        contratos: 5 },
  free:         limitesDoCatalogo.free,
  essential:    limitesDoCatalogo.essential,
  professional: limitesDoCatalogo.professional,
  enterprise:   limitesDoCatalogo.enterprise,
};

export function getPlanLimits(plan: PlanKey) {
  return PLAN_LIMITS[plan];
}
